// extracted by mini-css-extract-plugin
export default {"Header_title":"HeaderTitle_Header_title__jjhcz"};